module.exports = __webpack_public_path__ + "static/media/om.4944b831.svg";